import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Dropdown, DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {SearchDropdownHeader} from '../../../../../libs/shared/ui/src/components/dropdowns/search/searchDropdownHeader';
import {fontSizes} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../../libs/shared/ui/src/styles/mixins';
import tenorLogo from '../../../../assets/images/poweredByTenor.png';
import {GifModel} from '../../../../models/api/gifModel';
import {dropdownListHeight, dropdownWidth} from './gifDropdownCommons';
import {GifDropdownList} from './gifDropdownList';

/*
 * Props.
 */

interface GifDropdownProps extends DropdownProps {
  onGifSelect?: (model: GifModel) => void;
}

/*
 * Styles.
 */

const StyledDropdownListWrapper = styled.div`
  height: ${dropdownListHeight}px;
  ${center()};
`;

const StyledFooterDiv = styled.div`
  border-top: 1px solid ${(p) => p.theme.greys.shade30};
  padding: 8px 0 8px 0;
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.small};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledTenorLogoImage = styled.img`
  height: 18px;
  width: auto;
`;

export const GifDropdown: FC<GifDropdownProps> = ({onGifSelect, ...dropdownProps}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const onGifClick: (model: GifModel) => void = (gif) => onGifSelect && onGifSelect(gif);

  return (
    <Dropdown {...dropdownProps} width={dropdownWidth}>
      <SearchDropdownHeader
        title={<Trans id="dropdown-gif-title">GIF</Trans>}
        value={searchQuery}
        onChange={setSearchQuery}
      />
      <StyledDropdownListWrapper>
        <GifDropdownList query={searchQuery} onGifSelect={onGifClick} />
      </StyledDropdownListWrapper>
      <StyledFooterDiv>
        <StyledTenorLogoImage src={tenorLogo} />
      </StyledFooterDiv>
    </Dropdown>
  );
};
